var formatGBP = function formatGBP(amountInPence) {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }).format(amountInPence / 100);
};
export { formatGBP as default };